"use strict";

exports.__esModule = true;
exports.addAnimationEndListener = addAnimationEndListener;
exports.removeAnimationEndListener = removeAnimationEndListener;
exports.addAnimationStartListener = addAnimationStartListener;
exports.removeAnimationStartListener = removeAnimationStartListener;
exports.addTransitionEndListener = addTransitionEndListener;
exports.removeTransitionEndListener = removeTransitionEndListener;
exports.addTransitionStartListener = addTransitionStartListener;
exports.removeTransitionStartListener = removeTransitionStartListener;

var _reactHooks = require("@okee-uikit/react-hooks");

var animationEndEvents = (0, _reactHooks.getPrefixedEventKey)('AnimationEnd');
var animationStartEvents = (0, _reactHooks.getPrefixedEventKey)('AnimationStart');
var transitionEndEvents = (0, _reactHooks.getPrefixedEventKey)('TransitionEnd');
var transitionStartEvents = (0, _reactHooks.getPrefixedEventKey)('TransitionStart');

function addAnimationEndListener(element, listener) {
  animationEndEvents.forEach(function (event) {
    return element.addEventListener(event, listener);
  });
}

function removeAnimationEndListener(element, listener) {
  animationEndEvents.forEach(function (event) {
    return element.removeEventListener(event, listener);
  });
}

function addAnimationStartListener(element, listener) {
  animationStartEvents.forEach(function (event) {
    return element.addEventListener(event, listener);
  });
}

function removeAnimationStartListener(element, listener) {
  animationStartEvents.forEach(function (event) {
    return element.removeEventListener(event, listener);
  });
}

function addTransitionEndListener(element, listener) {
  transitionEndEvents.forEach(function (event) {
    return element.addEventListener(event, listener);
  });
}

function removeTransitionEndListener(element, listener) {
  transitionEndEvents.forEach(function (event) {
    return element.removeEventListener(event, listener);
  });
}

function addTransitionStartListener(element, listener) {
  transitionStartEvents.forEach(function (event) {
    return element.addEventListener(event, listener);
  });
}

function removeTransitionStartListener(element, listener) {
  transitionStartEvents.forEach(function (event) {
    return element.removeEventListener(event, listener);
  });
}